export const API_RESULT_TYPE = {
  RESPONSE: 'RESPONSE',
  ERROR: 'ERROR',
  ALREADY_HANDLED: 'ALREADY_HANDLED',
  LOCKED: 'LOCKED',
} as const;

type ObjectValues<T> = T[keyof T];

export type ApiResultType = ObjectValues<typeof API_RESULT_TYPE>;
